package team.platforma.multiplatform_material_extension.ui.theme

import androidx.compose.animation.AnimatedContent
import androidx.compose.animation.core.tween
import androidx.compose.animation.fadeIn
import androidx.compose.animation.fadeOut
import androidx.compose.animation.togetherWith
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Switch
import androidx.compose.material3.SwitchColors
import androidx.compose.material3.SwitchDefaults
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import materialextension.multiplatform_material_extension.generated.resources.Res
import materialextension.multiplatform_material_extension.generated.resources.moon
import materialextension.multiplatform_material_extension.generated.resources.sun
import org.jetbrains.compose.resources.painterResource

@Composable
fun ThemeSwitcher(
    modifier: Modifier? = null
) {
    Switch(
        modifier = modifier ?: Modifier,
        checked = Theme.isDark(),
        onCheckedChange = { changeTheme ->
            Theme.setDarkTheme(changeTheme)
        },
        thumbContent = {
            Box(
                modifier = Modifier
                    .size(40.dp)
                    .background(
                        color = Color.Black,
                        shape = CircleShape
                    ),
                contentAlignment = Alignment.Center
            ) {
                AnimatedContent(
                    targetState = Theme.isDark(),
                    transitionSpec = {
                        fadeIn(animationSpec = tween(250)) togetherWith fadeOut(
                            animationSpec = tween(150)
                        )
                    }
                ) { isDarkState ->
                    Icon(
                        modifier = Modifier.size(16.dp),
                        painter = painterResource(if (isDarkState) Res.drawable.moon else Res.drawable.sun),
                        contentDescription = "Switch theme",
                        tint = if (isDarkState) MaterialTheme.colorScheme.primary else Color.White
                    )
                }

            }
        },
        colors = SwitchDefaults.colors().copy(
            uncheckedBorderColor = MaterialTheme.colorScheme.primary
        )
    )
}